module.exports = __webpack_public_path__ + "static/media/photo49.4228ccce.jpg";